const history = {
  title: 'Mis proyectos',
  upgradeBtn: 'Actualizar',
  subTitle:
    'No olvide descargar su archivo, ya que se eliminará después de 72 horas.',
  MAgo: 'hace {{num}} minutos',
  HAgo: 'hace {{num}} horas',
  DAgo: 'hace {{num}} horas',
  justNow: 'Ahora mismo',
  originalFile: 'Archivo original',
  selectAllBtn: 'Seleccionar todo',
  emptyTips: 'No hay proyecto todavía. <1>Ir a editar</1>',
  deleteTips: '¿Estás seguro de eliminarlo?',
};

export default history;
